module.exports = __webpack_public_path__ + "static/img/6.bb59d58.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/6.png
// module id = +mH/
// module chunks = 0